import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import TitleDisplay from './TitleDisplay';
import EditDisplay from '../EditDisplay';
import AvInput from '../AvInput';
import AvGroup from '../AvGroup';
import SaveButton from '../SaveButton';

@inject('page')
@observer
export default class TitleEditor extends Component {
  @observable isEditing = false;
  @action openEditor = () => (this.isEditing = true);
  @action closeEditor = () => (this.isEditing = false);

  render() {
    const page = this.props.page;
    return (
      <AvForm onValidSubmit={this.closeEditor}>
        {this.isEditing ? (
          <AvGroup>
            <AvInput name="title" value={page.title} onChange={page.setTitle} required autoFocus />
            <SaveButton>save</SaveButton>
          </AvGroup>
        ) : (
          <EditDisplay onClick={this.openEditor}>
            <TitleDisplay>{page.title} ({page.quantity})</TitleDisplay>
          </EditDisplay>
        )}
      </AvForm>
    );
  }
}
